import * as moment from 'moment';
import { ImportTmsLoadsResult } from './tms-import/import-tms-loads-result';
import { ImportLoadsStatus } from './import-loads-status';

export class LocalImport {

  public id: string;
  public importedAt: moment.Moment;
  public userId: string;
  public userEmail: string;
  public status: ImportLoadsStatus;
  public source: string;
  public sourceFilename: string;
  public report: ImportTmsLoadsResult;

  static fromDto(i) {
    if (!i) {
      return null;
    }

    const localImport = new LocalImport();

    localImport.id             = i.id;
    localImport.importedAt     = i.imported_at ? moment(i.imported_at) : null;
    localImport.userId         = i.user_id;
    localImport.userEmail      = i.user_email;
    localImport.status         = i.status;
    localImport.source         = i.source;
    localImport.sourceFilename = i.source_filename;
    localImport.report         = ImportTmsLoadsResult.fromDto(i.report);

    return localImport;
  }
}
